import { CTABlock } from "@/components/shared/CTABlock";

type SectionToolsCTABlockProps = {
  className?: string;
};

export const SectionToolsCTABlock = ({ className }: SectionToolsCTABlockProps) => (
  <CTABlock
    heading={
      <>
        It’s time <span>to jumpstart</span> your paper!{" "}
      </>
    }
    subheading="Delegate your assignment to our experts and they will do the rest."
    btnText="Get custom essay"
    className={className}
  />
);
